// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"46":"splide","125":"accordian"}[chunkId] || chunkId) + "." + {"46":"cf0fdde494e5","125":"23e0536bc675","846":"598eb0f0a3f0"}[chunkId] + ".bundle.js";
};